import {BackgroundElementStyles} from "../elements/ElementStyles";
import {useContext, useEffect, useState} from "react";
import PlanerView, {isInPast} from "./PlanerView";
import {stylesPlanerView as stylesPlannerView} from "./SchedulePlanerViewStyles";
import {fetchLocations} from "../api/api";
import {weekdays} from "../ToDos";
import {APIContext} from "../Globals.tsx";

function calcDuration(start, end){
  return (new Date("2000-01-01T" + end) - new Date("2000-01-01T" + start)) / 3600000 * 60;
}

function calcHeight(item, lineHeight){
  return (new Date("2000-01-01T" + item.endTime) - new Date("2000-01-01T" + item.startTime)) / 3600000 * lineHeight;
}

export default function SchedulePlaner({week0, editSeries, setEditSeries, startOfWeek, addCourseTmp, date, preview = false}){
  const lineHeight = 1600 / 25;
  const raster = 2;

  const [mouse, setMouse] = useState({x: 0, y: 0});
  const [week, setWeek] = useState([[], [], [], [], [], [], []]);

  const [addCourse, setAddCourse] = useState(-1);
  const [addCoursePos, setAddCoursePos] = useState(-1);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState({});

  const [hoveredDay, setHoveredDay] = useState(-1);

  const [hoverItemHeight, setHoverItemHeight] = useState(lineHeight);
  const [hoverTop, setHoveredTop] = useState(-1);
  const [hoveredLeft, setHoveredLeft] = useState(-1);
  const [hoveredWidth, setHoveredWidth] = useState(-1);

  const [editValues, setEditValues] = useState(null);

  const [draggedItem, setDraggedItem] = useState(null);
  const [resizeItem, setResizeItem] = useState(null);

  const [locations, setLocations] = useState(null);
  const [courseTypes, setCourseTypes] = useState(null);
  const [coaches, setCoaches] = useState(null);

  const [weekdays_, setWeekdays] = useState(null);

  const padding = preview? 1: parseInt(BackgroundElementStyles.paddingLabels.split(" ")[1]);

  const {fetchCourseTypes, fetchCoaches} = useContext(APIContext)

  function startToInt(start){
    let parts = start.split(":");
    return parseFloat(parts[0]) + (parseFloat(parts[1]) / 60);
  }

  useEffect(()=>{
    setAddCourse(-1)
  },[editSeries])

  useEffect(() => {
    if(week0){
      if(date){
        setWeek(checkForParallels([week0[0]]));
      }
      else{
        setWeek(checkForParallels(week0));
      }
    }
  }, [week0]);

  useEffect(() => {
    setHoveredTop(getTop(-1));
    setHoveredLeft(getLeft(-1));
    setHoveredWidth(getWidthOfDay(-1));
  }, [addCourse]);

  useEffect(() => {
    fetchLocations().then(ans => setLocations(ans?.locations?.map(a => {
      return ({
        value: a.name,
        label: a.name,
        ...a
      });
    })));
    fetchCourseTypes().then(ans => setCourseTypes(ans?.types?.map(a => {
          return ({
            value: a.name,
            label: a.name,
            ...a
          });
        })
    ));
    fetchCoaches().then(ans => setCoaches(ans?.persons?.map(a => {
      return ({
        id: a.id,
        value: a.firstname+" "+a.lastname,
        label: a.firstname+" "+a.lastname
      });
    })));
  }, []);

  useEffect(()=>{
    if(date){
      const dayOfWeek = ((new Date(date)).getDay() + 6) % 7
      setWeekdays([weekdays[dayOfWeek]])
    }
    else{
      setWeekdays(weekdays)
    }
  },[date])

  function checkForParallels(week){
    week.map((day) => {
      day.map((item, i) => {
        const start = new Date("2000-01-01T" + item.startTime);
        const end = new Date("2000-01-01T" + item.endTime);
        item["parallels"] = [];
        item["parId"] = null;
        item["height"] = calcHeight(item, lineHeight);
        day.map((item_, i_) => {
          if(i !== i_){
            const start_ = new Date("2000-01-01T" + item_.startTime);
            const end_ = new Date("2000-01-01T" + item_.endTime);
            if(i !== i_ &&
              (start_ >= start && start_ < end ||
                end_ > start && end_ <= end ||
                start_ < start && end_ > end)){
              item.parallels.push(item_);
            }
          }
        });
      });
      day.map((item) => {
        if(item.parallels?.length > 0 && item.parId === null){
          item["parId"] = 0;
        }
        item["parallels"].map((item_, index) => {
          if(item_.parId === null){
            item_["parId"] = index + 1;
          }
        });
      });
      day.map((item) => {
          day.map((item_) => {
            if(item_.type === item.type &&
                !item.parallels.includes(item_) &&
                item_.parallels.length > 0 &&
                item.parallels.length > 0
            ){
              console.log("...");
              item_["parId"] = item["parId"];
            }
          });
      });
    });
    console.log(week);
    return week;
  }

  function handleMouseMove(e){
    const target = document.getElementById("DnDArea").getBoundingClientRect();
    if(e.clientY === 0){ //happens on drag-end via onDrag listener, just suppress
      return;
    }
    setMouse({
      x: e.clientX - target.left,
      y: e.clientY - target.top
    });
    setEditValues(null);
    if(e.clientX < target.left ||
      e.clientX > target.right ||
      e.clientY < target.top ||
      e.clientY > target.bottom){
      setHoveredDay(-1);
    }
    if(addCourse === -1){
      setHoveredTop(getTop(-1));
      setHoveredLeft(getLeft(-1));
      setHoveredWidth(getWidthOfDay(-1));
    }
  }

  function handleClick(e){
    if(addCourse === hoveredDay || e.isDefaultPrevented() || hoveredDay < 0 || week[hoveredDay][0]?.fixed || isInPast(startOfWeek, hoveredDay)){
      return;
    }
    setAddCourse(hoveredDay);
    setAddCoursePos(getTop());
  }

  function getLeft(day){
    const dndArea = document.getElementById("DnDArea").getBoundingClientRect().left;
    if(day > -1){
      return document.getElementById("s_day_" + day)?.getBoundingClientRect().left - dndArea + padding;
    }
    return document.getElementById("s_day_" + hoveredDay)?.getBoundingClientRect().left - dndArea;
  }

  function getWidthOfDay(day){
    let target;
    if(day > -1){
      target = document.getElementById("s_day_" + day)?.getBoundingClientRect();
      if(!target)
        return "100%"
      return target?.right - target?.left - padding * 2;
    }
    else{
      target = document.getElementById("s_day_" + hoveredDay)?.getBoundingClientRect();
      if(!target)
        return "100%"
      return target?.right - target?.left;
    }
  }

  function getWidthForElementRender(index, item){
    let max = item.parallels.length;
    item.parallels.map((ele) => max < ele.parallels.length ? max = ele.parallels.length : null);
    return getWidthOfDay(index) / (max + 1);
  }

  function getTop(){
    return Math.floor(mouse.y / (lineHeight / raster)) * (lineHeight / raster);
  }

  function calcPxToTime(px){
    const tmp = (px / lineHeight) - 1;
    const hour = Math.floor(tmp);
    const min = (tmp - hour) * 60;

    return hour.toString().padStart(2, "0") + ":" + min.toString().padStart(2, "0");
  }

  function handleDragEnd(){

    let tmp = [...week];
    let item = tmp[draggedItem.hoveredDay][draggedItem.i];

    if(resizeItem){
      addCourseTmp(item);
      setWeek(old => checkForParallels(old));
      return;
    }

    tmp[draggedItem.hoveredDay] = tmp[draggedItem.hoveredDay].filter((_, i) => i !== draggedItem.i);
    item.startTime = calcPxToTime(getTop());
    item.endTime = calcPxToTime(getTop() + item.height);
    tmp[hoveredDay].push(item);
    setDraggedItem(null);
    // if(editSeries){
    // }
    // else{
    //   delete item.id;
    //   delete item.repeat;
    //   item.startDate = new Date(new Date(startOfWeek).setDate(new Date(startOfWeek).getDate() + draggedItem.hoveredDay + 1));
    //   item.endDate = new Date(new Date(startOfWeek).setDate(new Date(startOfWeek).getDate() + draggedItem.hoveredDay + 1));
    // }
    setWeek(checkForParallels(tmp));
    let diff = hoveredDay-draggedItem.hoveredDay
    if(!item.repeat){
      item.startDate = new Date(new Date(startOfWeek).setDate(new Date(startOfWeek).getDate() + draggedItem.hoveredDay + diff));
      item.endDate = new Date(new Date(startOfWeek).setDate(new Date(startOfWeek).getDate() + draggedItem.hoveredDay + diff));
      }
    addCourseTmp(item);
  }

  function handleResize(){
    let tmp = week;
    let item = week[resizeItem.hoveredDay][resizeItem.i];
    let end = calcPxToTime(getTop() + (lineHeight / raster));
    let minEnd = new Date((new Date("2000-01-01T" + item.startTime)).getTime() + 3600000 / raster);
    let endTime = new Date("2000-01-01T" + end);
    item.endTime = (minEnd > endTime ? minEnd : endTime).toLocaleTimeString().substring(0, 5);
    item.height = calcHeight(item, lineHeight);
    // if(editSeries){
    //   delete item.components;
    //   tmp = tmp.map(day => day.map(course => course.id === item.id ? {...item} : course));
    // }
    // else{
    //   item.startDate = new Date(new Date(startOfWeek).setDate(new Date(startOfWeek).getDate() + resizeItem.hoveredDay + 1));
    //   item.endDate = new Date(new Date(startOfWeek).setDate(new Date(startOfWeek).getDate() + resizeItem.hoveredDay + 1));
    // }
    setWeek(checkForParallels(tmp));
  }

  function addCourseToWeek(props){
    let tmp = week;

    if(props.index < 0){
      tmp[addCourse].push({...props});
    }
    else{
      tmp[addCourse][props.index] = {...props}
    }
    setHoverItemHeight(lineHeight / 60 * calcDuration(props.startTime, props.endTime));
    setAddCourse(-1);
    setWeek(checkForParallels(tmp));

    addCourseTmp(props);

  }

  function onDelete(e, index, i, element){
    if(!deleteModal){
      setDeleteModal(true);
      setDeleteData({day: index, i: i, element: element})
      e.preventDefault()
    } else {
      setDeleteModal(false);
      if(e === 0){
        let tmp = week;
        tmp[deleteData.day] = tmp[deleteData.day].filter((_, ii) => ii !== deleteData.i);
        setWeek(checkForParallels(tmp));

        deleteData.element.status = "canceled"
        addCourseTmp(deleteData.element);
      }
    }
  }


  return (
    <PlanerView getWidth={getWidthForElementRender} setHoverItemHeight={setHoverItemHeight} addToWeek={addCourseToWeek}
                hoverItemHeight={hoverItemHeight} setDraggedItem={setDraggedItem} addCoursePos={addCoursePos}
                week={week} addModal={addCourse} setAddModal={setAddCourse} calcPxToTime={calcPxToTime}
                draggedItem={draggedItem} editValues={editValues} hoveredWidth={hoveredWidth}
                handleDragEnd={handleDragEnd} handleResize={handleResize} hoveredDay={hoveredDay}
                hoveredLeft={hoveredLeft} getLeft={getLeft} hoverTop={hoverTop} getTop={getTop}
                lineHeight={lineHeight} handleClick={handleClick} handleMouseMove={handleMouseMove}
                resizeItem={resizeItem} setResizeItem={setResizeItem} setEditValues={setEditValues}
                setHoveredDay={setHoveredDay} setSelectedCourseType={null} checkbox={editSeries}
                onCheckbox={() => setEditSeries(!editSeries)} stylesPlanerView={stylesPlannerView}
                startToInt={startToInt} startOfWeek={startOfWeek} courseTypes={courseTypes} locations={locations}
                coaches={coaches} getWidthOfDay={getWidthOfDay} weekdays={weekdays_} preview={preview} onDelete={onDelete} deleteModal={deleteModal}/>)
}